import { useTranslation } from "react-i18next";
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Container, Row, Col, Form, FormGroup, Label, Input, Button, Card, CardBody, CardHeader } from 'reactstrap';
import logo from '../assets/logo_green_tm.png';

const SignUpNotify = () => {
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    companyName: '',
    title: ''
  });
  const [status, setStatus] = useState({
    loading: false,
    success: false,
    error: null
  });

  const handleChange = e => {
    setFormData({ ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setStatus({
      loading: true,
      success: false,
      error: null
    }); // Basic frontend validation

    if (!formData.firstName || !formData.lastName || !formData.email) {
      setStatus({
        loading: false,
        success: false,
        error: 'First name, last name, and email are required.'
      });
      return;
    }

    try {
      const response = await fetch('/api/waitlist', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      const data = await response.json();

      if (response.ok && data.success) {
        setStatus({
          loading: false,
          success: true,
          error: null
        });
        setFormData({
          firstName: '',
          lastName: '',
          email: '',
          companyName: '',
          title: ''
        });
      } else {
        setStatus({
          loading: false,
          success: false,
          error: data.error || 'Something went wrong.'
        });
      }
    } catch (error) {
      setStatus({
        loading: false,
        success: false,
        error: 'Network error. Please try again later.'
      });
    }
  };

  return <div className='page-header d-flex align-items-center' style={{
    minHeight: '100vh',
    paddingTop: '60px',
    paddingBottom: '40px',
    overflowY: 'auto'
  }}>
      <Container>
        <Row className='justify-content-center'>
          <Col md={8} lg={6}>
            <Card className='shadow-lg border-0 rounded-lg' style={{
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            margin: 0
          }}>
              <CardHeader className='bg-primary text-white text-center rounded-top position-relative py-4'>
                <img src={logo} alt={t("HeresMyInfo")} style={{
                position: 'absolute',
                top: '15px',
                left: '15px',
                width: '120px'
              }} />
                <button className='close text-white' style={{
                position: 'absolute',
                top: '15px',
                right: '15px',
                textShadow: 'none',
                opacity: 0.8
              }} onClick={() => history.push('/')} aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <h3 className='font-weight-light my-2' style={{
                color: 'white'
              }}>{t("Sign up to be notified when we release!")}</h3>
              </CardHeader>
              <CardBody>
                {status.success ? <div className='text-center py-5'>
                    <i className='fas fa-check-circle text-success fa-3x mb-3'></i>
                    <h4 className='text-success mb-2'>{t("Thanks for signing up!")}</h4>
                    <p className='mb-0'>{t("We've sent a confirmation email to your inbox.")}</p>
                  </div> : <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col xs={6}>
                        <FormGroup className='mb-3'>
                          <Label for='firstName' className='mb-1'>{t("First Name *")}</Label>
                          <Input type='text' name='firstName' id='firstName' placeholder={t("First name")} value={formData.firstName} onChange={handleChange} required />
                        </FormGroup>
                      </Col>
                      <Col xs={6}>
                        <FormGroup className='mb-3'>
                          <Label for='lastName' className='mb-1'>{t("Last Name *")}</Label>
                          <Input type='text' name='lastName' id='lastName' placeholder={t("Last name")} value={formData.lastName} onChange={handleChange} required />
                        </FormGroup>
                      </Col>
                    </Row>
                    <FormGroup className='mb-3'>
                      <Label for='email' className='mb-1'>{t("Email Address *")}</Label>
                      <Input type='email' name='email' id='email' placeholder={t("Enter your email address")} value={formData.email} onChange={handleChange} required />
                    </FormGroup>
                    <FormGroup className='mb-3'>
                      <Label for='companyName' className='mb-1'>{t("Company Name (Optional)")}</Label>
                      <Input type='text' name='companyName' id='companyName' placeholder={t("Enter your company name")} value={formData.companyName} onChange={handleChange} />
                    </FormGroup>
                    <FormGroup className='mb-3'>
                      <Label for='title' className='mb-1'>{t("Title (Optional)")}</Label>
                      <Input type='text' name='title' id='title' placeholder={t("Enter your job title")} value={formData.title} onChange={handleChange} />
                    </FormGroup>
                    {status.error && <div className='alert alert-danger mb-3'>{status.error}</div>}
                    <div className='mt-3 mb-0'>
                      <Button color='primary' block type='submit' disabled={status.loading} size='lg'>
                        {status.loading ? 'Submitting...' : 'Sign Up for Notifications'}
                      </Button>
                    </div>
                  </Form>}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>;
};

export default SignUpNotify;